/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
    ApiResult,
    OrganisationPreferenceDto,
    OrganisationPreferenceResponseItem,
    UptimePreferenceRequest,
    UptimePreferenceResponse,
} from "../models/index";
import {
    ApiResultFromJSON,
    ApiResultToJSON,
    OrganisationPreferenceDtoFromJSON,
    OrganisationPreferenceDtoToJSON,
    OrganisationPreferenceResponseItemFromJSON,
    OrganisationPreferenceResponseItemToJSON,
    UptimePreferenceRequestFromJSON,
    UptimePreferenceRequestToJSON,
    UptimePreferenceResponseFromJSON,
    UptimePreferenceResponseToJSON,
} from "../models/index";

export interface GetOrganisationPreferencesRequest {
    organisationId?: string;
}

export interface SetOrganisationPreferenceRequest {
    body?: OrganisationPreferenceDto;
}

export interface SetUptimePreferenceRequest {
    body?: UptimePreferenceRequest;
}

/**
 *
 */
export class OrganisationPreferencesHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Get organisation preference schemas and the current values for an organisation.
     */
    async getOrganisationPreferencesRaw(
        requestParameters: GetOrganisationPreferencesRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<OrganisationPreferenceResponseItem>>> {
        const queryParameters: any = {};

        if (requestParameters["organisationId"] != null) {
            queryParameters["organisationId"] =
                requestParameters["organisationId"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/organisation-preferences`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(OrganisationPreferenceResponseItemFromJSON),
        );
    }

    /**
     * Get organisation preference schemas and the current values for an organisation.
     */
    async getOrganisationPreferences(
        requestParameters: GetOrganisationPreferencesRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<OrganisationPreferenceResponseItem>> {
        const response = await this.getOrganisationPreferencesRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get the uptime calculation preference for the current user\'s organisation. Returns true if offline periods should be included in uptime calculations, false if offline periods should be excluded. Returns null if not set.
     */
    async getUptimePreferenceRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<UptimePreferenceResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/organisation-preferences/uptime`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            UptimePreferenceResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get the uptime calculation preference for the current user\'s organisation. Returns true if offline periods should be included in uptime calculations, false if offline periods should be excluded. Returns null if not set.
     */
    async getUptimePreference(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<UptimePreferenceResponse> {
        const response = await this.getUptimePreferenceRaw(initOverrides);
        return await response.value();
    }

    /**
     * Set an organisation preference value. If OrganisationId is omitted in the payload, the current user\'s organisation is used.
     */
    async setOrganisationPreferenceRaw(
        requestParameters: SetOrganisationPreferenceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/organisation-preferences`,
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
                body: OrganisationPreferenceDtoToJSON(
                    requestParameters["body"],
                ),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Set an organisation preference value. If OrganisationId is omitted in the payload, the current user\'s organisation is used.
     */
    async setOrganisationPreference(
        requestParameters: SetOrganisationPreferenceRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.setOrganisationPreferenceRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Set the uptime calculation preference for the current user\'s organisation. Set to true to include offline periods in uptime calculations (UptimeOfflineIncluded), or false to exclude offline periods (UptimeOfflineExcluded). Requires Permission.organisation_preferences_manage.
     */
    async setUptimePreferenceRaw(
        requestParameters: SetUptimePreferenceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/organisation-preferences/uptime`,
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
                body: UptimePreferenceRequestToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Set the uptime calculation preference for the current user\'s organisation. Set to true to include offline periods in uptime calculations (UptimeOfflineIncluded), or false to exclude offline periods (UptimeOfflineExcluded). Requires Permission.organisation_preferences_manage.
     */
    async setUptimePreference(
        requestParameters: SetUptimePreferenceRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.setUptimePreferenceRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}
